module.exports = {
      id: "user-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#user",
      toString: function () {
        return this.url;
      }
    }